<template>
  <div>
      <div class="row mb-4 mt-4">
          <div class="col">
              <div class="card">
                  <div class="collapse show">
                      <div class="card-body">
                          <div class="card-text">
                              <h3><span style='color:Tomato'> <strong>ESTER Leaderboard</strong></span></h3>
                            <hr>
                             <table class="paleBlueRows">
                                <thead>
                                <tr>
                                    <th>Rank</th>
                                    
                                    <th>Model</th>

                                    <th>F1</th>
                                    <th>HIT@1</th>
                                    <th>EM</th>

                                    
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>1</td>
                                    
                                    <td>UnifiedQA-large <br> <a style='color:Tomato' href="https://arxiv.org/abs/2005.00700">Paper</a> </td>
                                    <td>63.3</td>
                                    <td>83.5</td>
                                    <td>22.1</td>
                                    
                                </tr>
                                <tr>
                                    <td>2</td>
                                    
                                    <td>UnifiedQA-base <br> <a style='color:Tomato' href="https://arxiv.org/abs/2005.00700">Paper</a></td>
                                    <td>59.3</td>
                                    <td>78.1</td>
                                    <td>20.6</td>
                                    
                                </tr>
                                <tr>
                                    <td>3</td>
                                    
                                    <td>T5-base <br> <a style='color:Tomato' href="https://arxiv.org/abs/1910.10683">Paper</a> </td>
                                    <td>58.5</td>
                                    <td>76.2</td>
                                    <td>20.5</td>
                                    
                                </tr>

                                <tr>
                                    <td>4</td>
                                    
                                    <td>RoBERTa-large <br> <a style='color:Tomato' href="https://arxiv.org/abs/1907.11692">Paper</a> </td>
                                    <td>66.1</td>
                                    <td>63.8</td>
                                    <td>15.9</td>
                                    
                                </tr>

                                <tr>
                                    <td>5</td>
                                    
                                    <td>BART-large <br> <a style='color:Tomato' href="https://arxiv.org/abs/1910.13461">Paper</a> </td>
                                    <td>56.1</td>
                                    <td>71.5</td>
                                    <td>15.2</td>
                                    
                                </tr>

                                </tbody>
                            </table>
                              
                            <hr>

                            <span style='color:Tomato'> <h4> Submit to ESTER Leaderbord </h4></span> 
                            <ul>
                            <li> Please follow the instruction <a href="https://github.com/PlusLabNLP/ESTER">here</a> to output a <strong>pred_test.json</strong> file for the test set. </li>
                            <li> Email this file to <a href="mailto:rujunhan@usc.edu">rujunhan@usc.edu</a> with the title "[ESTER Submission] - your model name" </li>
                            <li> It would be great to include a 1-2 line description of your model, but not required. </li>
                             
                            </ul>

                            <hr>
                            <span style='color:Tomato'> <h4> Ranking Models </h4></span> 
                            In order to emphasize the importance of using multiple metrics to evaluate models, we use a <strong> weighted average </strong> of all three evaluation metrics to rank models. Please refer to our paper for detailed explanations of evaluation metrics.
                          
                            <hr>
                            <h4> Citation </h4>

                              @article{han-etal-ester-21, <br>
                               <div style="margin-left: 4em">author = {Rujun Han and I-Hung Hsu and Jiao Sun and Julia Baylon and</div>
                               <div style="margin-left: 8.3em">Qiang Ning and Dan Roth and Nanyun Peng}</div>
                               <div style="margin-left: 4em">title = {ESTER: A Machine Reading Comprehension Dataset for Event Semantic Relation Reasoning},</div>
                               <div style="margin-left: 4em">journal = {arXiv preprint},</div>
                               <div style="margin-left: 4em">volume = {arXiv:2104.08350},</div>
                               <div style="margin-left: 4em">year = {2021}</div>
                                }
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Payment',
  props: {
      max_bonus: Number,
      bonus_per_question: Number
  },
    filters: {
        currency: function(value){
            return value.toFixed(2);
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
